import { render } from "./rolePopup.vue?vue&type=template&id=ed5c55a6"
import script from "./rolePopup.vue?vue&type=script&lang=js"
export * from "./rolePopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../less/rolePopup.less?vue&type=style&index=0&module=true&lang=css&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__